import {axiosInstance} from "./base";

export const getAppConfig = () => axiosInstance.get("/api/v1/app/config/idp");
